export default __webpack_public_path__ + "static/media/Visual_joil_13.0cf4a316.jpg";